import { BrandAdTokenValue } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";
import { brandAdTokenValuesUrl } from "./cmdGetBrandAdTokenValues";

/** Only the value changes; a different ad token is a different row. */
export class CommandUpdateBrandAdTokenValue {
    async run(organizationId: string, brandId: string, valueUuid: string, value: string): Promise<BrandAdTokenValue> {
        const url = `${brandAdTokenValuesUrl(organizationId, brandId)}${encodeURIComponent(valueUuid)}/`;
        return await httpRequest<BrandAdTokenValue>(url, { method: "PUT", body: { value } });
    }
}
